<template>
  <div class="inspection-route-container">
    <el-row :gutter="16">
      <!-- 左侧路线导航 -->
      <el-col :xs="24" :sm="24" :md="6" :lg="5">
        <div class="ds-nav-card">
          <div class="ds-nav-card__header">{{ $t('inspectionRoute.page.listTitle') }}</div>
          <div class="ds-nav-card__filter">
            <el-input v-model="inspectionRouteInfo.conditions.routeName" clearable class="w-full"
              :placeholder="$t('inspectionRoute.routeNamePlaceholder')"
              @keyup.enter.native="_queryInspectionRouteMethod" />
            <div class="ds-nav-card__filter-actions">
              <el-button type="text" icon="el-icon-search" @click="_queryInspectionRouteMethod">
                {{ $t('common.search') }}
              </el-button>
              <el-button type="text" icon="el-icon-plus" @click="_openAddInspectionRouteModal">
                {{ $t('common.add') }}
              </el-button>
            </div>
          </div>
          <el-scrollbar class="ds-nav-card__scroll">
            <ul class="ds-nav-card__list">
              <li v-for="(route, index) in inspectionRouteInfo.inspectionRoutes" :key="index" class="ds-nav-card__item"
                :class="{ 'is-active': route.inspectionRouteId == inspectionRouteInfo.route.inspectionRouteId }"
                @click="_switchInspectionRoute(route)">
                <i class="el-icon-guide"></i>
                <span class="ds-nav-card__name">{{ route.routeName }}</span>
              </li>
            </ul>
          </el-scrollbar>
        </div>
      </el-col>

      <el-col :xs="24" :sm="24" :md="18" :lg="19">
        <template v-if="inspectionRouteInfo.route.inspectionRouteId">
          <!-- (1) PageHeader -->
          <ds-page-header :title="$t('inspectionRoute.routeInfo')" :subtitle="inspectionRouteInfo.route.routeName">
            <template #extra>
              <el-button icon="el-icon-edit" @click="_openEditInspectionRouteModel(inspectionRouteInfo.route)">
                {{ $t('common.edit') }}
              </el-button>
              <el-button icon="el-icon-delete" class="ds-btn-danger"
                @click="_openDeleteInspectionRouteModel(inspectionRouteInfo.route)">
                {{ $t('common.delete') }}
              </el-button>
            </template>
          </ds-page-header>

          <!-- 详情信息面板 -->
          <div class="ds-panel ds-panel--detail">
            <el-row :gutter="16">
              <el-col :xs="24" :sm="12" :md="6" :lg="6">
                <div class="ds-field">
                  <div class="ds-field__label">{{ $t('inspectionRoute.routeName') }}</div>
                  <div class="ds-field__value">{{ inspectionRouteInfo.route.routeName || '-' }}</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="6" :lg="6">
                <div class="ds-field">
                  <div class="ds-field__label">{{ $t('inspectionRoute.sequence') }}</div>
                  <div class="ds-field__value ds-num">{{ inspectionRouteInfo.route.seq }}</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="6" :lg="6">
                <div class="ds-field">
                  <div class="ds-field__label">{{ $t('inspectionRoute.createTime') }}</div>
                  <div class="ds-field__value ds-num">{{ inspectionRouteInfo.route.createTime || '-' }}</div>
                </div>
              </el-col>
              <el-col :xs="24" :sm="12" :md="6" :lg="6">
                <div class="ds-field">
                  <div class="ds-field__label">{{ $t('inspectionRoute.remark') }}</div>
                  <div class="ds-field__value">{{ inspectionRouteInfo.route.remark || '-' }}</div>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 标签页面板 -->
          <div class="ds-panel ds-panel--tabs">
            <el-tabs v-model="inspectionRouteInfo._currentTab" @tab-click="changeTab(inspectionRouteInfo._currentTab)">
              <el-tab-pane :label="$t('inspectionRoute.tabs.routePoint')" name="inspectionRoutePoint">
                <inspection-route-point ref="inspectionRoutePoint" />
              </el-tab-pane>
              <el-tab-pane :label="$t('inspectionRoute.tabs.routeMap')" name="inspectionRouteMap">
                <inspection-route-map ref="inspectionRouteMap" />
              </el-tab-pane>
              <el-tab-pane :label="$t('inspectionRoute.tabs.routePlan')" name="routePlan">
                <route-plan ref="routePlan" />
              </el-tab-pane>
              <el-tab-pane :label="$t('inspectionRoute.tabs.routeTask')" name="routeTask">
                <route-task ref="routeTask" />
              </el-tab-pane>
            </el-tabs>
          </div>
        </template>

        <!-- 未选中路线时的空态 -->
        <div v-else class="ds-panel ds-panel--empty">
          <ds-empty-state :description="$t('inspectionRoute.page.empty')" />
        </div>
      </el-col>
    </el-row>

    <add-inspection-route ref="addInspectionRoute" @success="handleSuccess" />
    <edit-inspection-route ref="editInspectionRoute" @success="handleSuccess" />
    <delete-inspection-route ref="deleteInspectionRoute" @success="handleSuccess" />
  </div>
</template>

<script>
import { getCommunityId } from '@/api/community/communityApi'
import {
  listInspectionRoutes,

} from '@/api/inspection/inspectionRouteApi'
import InspectionRoutePoint from '@/components/inspection/InspectionRoutePoint'
import InspectionRouteMap from '@/components/inspection/inspectionRouteMap'
import RoutePlan from '@/components/inspection/RoutePlan'
import RouteTask from '@/components/inspection/RouteTask'
import AddInspectionRoute from '@/components/inspection/AddInspectionRoute'
import EditInspectionRoute from '@/components/inspection/EditInspectionRoute'
import DeleteInspectionRoute from '@/components/inspection/DeleteInspectionRoute'
import DsPageHeader from '@/components/ds/ds-page-header.vue'
import DsEmptyState from '@/components/ds/ds-empty-state.vue'

export default {
  name: 'InspectionRouteList',
  components: {
    InspectionRoutePoint,
    InspectionRouteMap,
    RoutePlan,
    RouteTask,
    AddInspectionRoute,
    EditInspectionRoute,
    DeleteInspectionRoute,
    DsPageHeader,
    DsEmptyState
  },
  data() {
    return {
      inspectionRouteInfo: {
        inspectionRoutes: [],
        route: {},
        _currentTab: 'inspectionRoutePoint',
        conditions: {
          routeName: '',
          inspectionRouteId: '',
          seq: ''
        }
      },
      communityId: ''
    }
  },
  created() {
    this.communityId = getCommunityId()
    this._listInspectionRoutes(1, 100)
  },
  methods: {
    async _listInspectionRoutes(page, rows) {
      try {
        const params = {
          page,
          row: rows,
          communityId: this.communityId,
          ...this.inspectionRouteInfo.conditions
        }
        const data = await listInspectionRoutes(params)
        this.inspectionRouteInfo.inspectionRoutes = Array.isArray(data.inspectionRoutes) ? data.inspectionRoutes : []
        if (data.inspectionRoutes && data.inspectionRoutes.length > 0) {
          this._switchInspectionRoute(data.inspectionRoutes[0])
        }
      } catch (error) {
        console.error('获取巡检路线失败:', error)
      }
    },
    _openAddInspectionRouteModal() {
      this.$refs.addInspectionRoute.open()
    },
    _openEditInspectionRouteModel(route) {
      this.$refs.editInspectionRoute.open(route)
    },
    _openDeleteInspectionRouteModel(route) {
      this.$refs.deleteInspectionRoute.open(route)
    },
    _queryInspectionRouteMethod() {
      this._listInspectionRoutes(1, 100)
    },
    _switchInspectionRoute(route) {
      this.inspectionRouteInfo.route = route
      this.changeTab(this.inspectionRouteInfo._currentTab)
    },
    changeTab(tab) {
      this.inspectionRouteInfo._currentTab = tab
      setTimeout(() => {
        if (this.$refs[tab]) {
          this.$refs[tab].loadData(this.inspectionRouteInfo.route)
        }
      }, 500)
    },
    handleSuccess() {
      this._listInspectionRoutes(1, 100)
    }
  }
}
</script>

<style lang="scss" scoped>
.inspection-route-container {
  padding: var(--ds-spacing-lg);
  background-color: var(--ds-gray-100);
  min-height: calc(100vh - 60px);
}

/* 左侧路线导航卡片 */
.ds-nav-card {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &__header {
    padding: var(--ds-spacing-sm) var(--ds-spacing-lg);
    font-size: var(--ds-font-size-sm);
    font-weight: 600;
    color: var(--ds-gray-700);
    background: var(--ds-gray-100);
    border-bottom: 1px solid var(--ds-gray-200);
  }

  &__filter {
    padding: var(--ds-spacing-sm) var(--ds-spacing-md);
    border-bottom: 1px solid var(--ds-gray-200);

    &-actions {
      display: flex;
      align-items: center;
      gap: var(--ds-spacing-xs);
      margin-top: var(--ds-spacing-xs);
    }
  }

  &__scroll {
    max-height: calc(100vh - 340px);
  }

  &__list {
    list-style: none;
    margin: 0;
    padding: var(--ds-spacing-sm);
  }

  &__item {
    display: flex;
    align-items: center;
    gap: var(--ds-spacing-sm);
    padding: var(--ds-spacing-sm) var(--ds-spacing-md);
    margin-bottom: var(--ds-spacing-xs);
    border-radius: var(--ds-radius-sm);
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-700);
    cursor: pointer;
    transition: background-color var(--ds-transition-fast),
      color var(--ds-transition-fast);

    &:hover {
      background-color: rgba(var(--ds-primary-rgb), 0.08);
      color: var(--ds-primary);
    }

    &.is-active {
      background-color: var(--ds-primary);
      color: #fff;
      font-weight: 600;
    }
  }

  &__name {
    flex: 1;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

/* 白色面板 */
.ds-panel {
  background: #fff;
  border: 1px solid var(--ds-gray-300);
  border-radius: var(--ds-radius-md);
  box-shadow: var(--ds-shadow-sm);
  overflow: hidden;

  &--detail {
    padding: var(--ds-spacing-lg);
    margin-bottom: var(--ds-spacing-md);
  }

  &--tabs {
    padding: 0 var(--ds-spacing-lg) var(--ds-spacing-md);
  }

  &--empty {
    padding: var(--ds-spacing-lg);
  }
}

/* 详情字段 */
.ds-field {
  &__label {
    font-size: var(--ds-font-size-xs);
    color: var(--ds-gray-500);
    margin-bottom: var(--ds-spacing-xs);
  }

  &__value {
    font-size: var(--ds-font-size-sm);
    color: var(--ds-gray-800);
    font-weight: 500;
    word-break: break-all;
  }
}

/* 危险操作按钮 */
.ds-btn-danger {
  color: var(--ds-danger) !important;
}
</style>
